import { render } from "./Proofreading.vue?vue&type=template&id=09bdb5a1&scoped=true"
import script from "./Proofreading.vue?vue&type=script&lang=js"
export * from "./Proofreading.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bdb5a1"]])

export default __exports__